<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Start afregninger manuelt</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Type</mat-label>
        <mat-select formControlName="afregningsType" (selectionChange)="onAfregningsTypeChanged($event.value)">
          @for (afregningsType of afregningsTypes; track afregningsType) {
            <mat-option [value]="afregningsType">{{ afregningsType }}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix class="select-arrow">keyboard_arrow_down</mat-icon>
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Kunde/Partner</mat-label>
        <mat-select formControlName="opkraevningsScope" (selectionChange)="onOpkraevningsScopeChanged($event.value)">
          @for (opkraevningsScope of opkraevningsScopes; track opkraevningsScope) {
            <mat-option [value]="opkraevningsScope">{{ opkraevningsScope }}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix class="select-arrow">keyboard_arrow_down</mat-icon>
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Start afregning</button>
</div>
